import { render, staticRenderFns } from "./AddProductAttributesSuccessStep.vue?vue&type=template&id=96506cc4"
import script from "./AddProductAttributesSuccessStep.ts?vue&type=script&lang=ts&external"
export * from "./AddProductAttributesSuccessStep.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports